/** @jsxImportSource @emotion/react */
import type { css } from '@emotion/react'

import type { BlocksQrWidgetComponent } from '@twisto/api-cms'

import { AccessibleDiv, DynamicContent, StrapiMedia } from '../../atoms'

import { clickableWidget, reversedWidget, widget } from './qr-widget.styles'

type QRWidgetProps = BlocksQrWidgetComponent & {
  styles?: ReturnType<typeof css>
}

export const QRWidget = ({
  background,
  headline,
  reversed,
  src,
  styles,
  url,
}: QRWidgetProps) => {
  const handleUrlClick = () => {
    if (url) {
      window.open(url, '_blank')
    }
  }

  return (
    <AccessibleDiv
      css={[widget, styles, reversed && reversedWidget, url && clickableWidget]}
      role="link"
      style={{ backgroundColor: background }}
      onActivate={handleUrlClick}
    >
      <StrapiMedia {...src} height={96} width={96} />
      <DynamicContent content={headline} />
    </AccessibleDiv>
  )
}
